import FrequencySelect from "@/components/form/frequency-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";
import type { ListItemFrequency } from "@/types/openapi-enum";

export type FrequencyFieldProps = PickerFieldProps<ListItemFrequency>;

export const FrequencyField = makePickerField<ListItemFrequency>({
  name: "FrequencyField",
  control: FrequencySelect,
  popout: true,
});
